const BASE_URL = process.env.REACT_APP_API_URL || 'https://gec-dev-backend.energymarketplace.in/gec-backend';
const API_V1_BASE_URL = BASE_URL + "/api/v1"
const API_V1 = "/api/v1"
const API_V2 = "/api/v2"
const API_ENDPOINTS = {
    // Auth endpoints
    AUTH: {
        LOGIN: API_V1 + '/users/login',
        LOGOUT: API_V1 + '/auth/logout',
        REFRESH: API_V1 + '/auth/refresh-tokens',
        PROFILE: API_V1 + '/auth/profile',
        ME: API_V1 + '/auth/me',
        REGISTER: API_V2 + "/users/register",
        VERIFY_OTP: API_V1 + "/auth/validate-otp",
        FORGOT_PASSWORD: {
            VERIFY_USER: API_V1 + "/auth/forgot-password",
            RESEND_OTP: API_V2 + "/auth/resend-otp",
            VERIFY_OTP: (token: string) => `/auth/verify-email?token=${token}`
        },
        RESET_PASSWORD: (token: string) => `/auth/reset-password`
    },

    CONSUMER_DETAILS_BY_CONSUMER_NO: API_V1 + "/company/consumer/details",
    DROPDOWN: {
        TIMESLOTS: API_V1 + "/dropdowns/timeslots"
    },
    UPLOAD_DOCUMENT: API_V1 + "/document/upload",

    DASHBOARD: {
        // OVERVIEW: API_V1 + "/dashboard/admin/overview",
        // GENERATOR_GRAPH: API_V1 + "/dashboard/admin/chart/generation",
        // CONSUMPTION_GRAPH: API_V1 + "/dashboard/admin/chart/consumption",
        // RECENT_REPORT_LIST: API_V1 + "/admin/recent/activity",
        ENERGY_HEATMAP: API_V1 + "/dashboard/consumer/heatmap",
        ENERGY_HEATMAP_SLOT_DETAILS: API_V1 + "/dashboard/consumer/generator-settlements",
        DASHBOARD_SUMMARY: API_V2 + "/dashboard/consumer/summary",
        RECENT_CERTIICATES: API_V1 + "/dashboard/consumer/recent-certificates",
        CO2_EMISSION: API_V1 + "/dashboard/consumer/co2-emission",
        CONSUMPTION_CHART: API_V1 + "/dashboard/consumer/readings",
        CONSUMPTION_OVERVIEW_LIST: API_V1 + "/dashboard/consumer/overview",
        ENERGY_BREAKDOWN: API_V1 + '/dashboard/consumer/energy-breakdown',
        CONSUMER_ESG: API_V1 + "/dashboard/consumer/esg",
        CONSUMER_RE100: API_V1 + "/dashboard/consumer/re100",
        CONSUMER_TARRIF_REPORT: API_V1 + "/dashboard/consumer/sbti_scope",
        CONSUMER_AUDIT_SUMMARY: API_V1 + "/dashboard/consumer/audit/summary",
        CONSUMER_TOLLTIL_LIST: API_V1 + "/dashboard/consumer/audit/list"



    },

    ENERGY_MONITORING_DASHBOARD: {
        STATS: API_V1 + "/dashboard/consumer/readings/summary",
        CHART: API_V1 + "/dashboard/consumer/readings",
        CO2_EMISSION: API_V1 + "/dashboard/consumer/co2-emission",
        CONSUMPTION_CHART: API_V1 + "/dashboard/consumer/readings",
        CONSUMPTION_OVERVIEW_LIST: API_V1 + "/dashboard/consumer/overview",
        ENERGY_BREAKDOWN: API_V1 + '/dashboard/consumer/energy-breakdown',
        CONSUMER_ESG: API_V1 + "/dashboard/consumer/esg",
        CONSUMER_RE100: API_V1 + "/dashboard/consumer/re100",
        CONSUMER_TARRIF_REPORT: API_V1 + "/dashboard/consumer/sbti_scope"

    },

    ENERGY_AUDIT: {
        CONSUMER: {
            COSNUMER_DETAILS: API_V1 + "/dashboard/consumer/audit/summary",
            REPORT: API_V1 + "/dashboard/consumer/audit/list"
        },
        GENERATOR: {
            COSNUMER_DETAILS: API_V1 + "/dashboard/admin/generator/audit/summary",
            REPORT: API_V1 + "/dashboard/admin/generator/audit/list"
        }
    },
    ONBOARDING: {
        GENERATORS: {
            REPORT: API_V1 + "/dashboard/generator/list",
            UPDATE_STATUS: (id: string) => `/admin/generators/${id}/status`
        }
    },

    GEC_CERTIFICATE_REPORT: {
        STATS: API_V1 + "/dashboard/consumer/tokens/summary",
        REPORT: API_V1 + "/dashboard/consumer/certificate",
        CHART_DETAILS: API_V1 + "/dashboard/consumer/tokens/detail",
        REPORT_DETAILS: (id: string) => API_V1 + `/dashboard/consumer/certificate/${id}/detail`,
        CERTIFICATE_DETAILS: API_V1 + "/dashboard/consumer/certificate/:certificateId/info",
        REPORT_DETAILS_EXPORT: (id: string) => API_V2 + `/dashboard/consumer/certificate/${id}/detail`,
        TOKENS_HISTORY: API_V2 + "/users/consumer/tokens/list",
        TOKEN_OWNERSHIP_HISTORY: API_V2 + "/users/consumer/tokens/list/transaction"

    },

    VERIFY_CERTIFICATE: {
        CERTIFICATE_DETAILS: API_V1 + "/certificate/verify",
    },

    SELF_SERVICE: {
        QUERY_REQUEST: {
            ALL_REQUESTS: API_V1 + "/ticket/list",
            POST_QUERY_REQUEST: API_V1 + "/ticket/raise",
            QUERY_DETAILS: API_V1 + "/ticket/details/:ticketId",
            COMMENT: API_V1 + "/ticket/comment"
        }
    },

    OPT_ENERGY_FORM_MODAL: API_V1 + "/users/energy-request/submit",
    BILLING: {
        BILLING_LIST: API_V1 + "/dashboard/consumer/billing/list",
        BILL_SUMMARY: API_V1 + "/dashboard/consumer/billing/summary"
    },
    ENERGY_IMPACT: {
        DASHBOARD_SUMMARY: API_V2 + "/impact/dashboard",
        IMPACT_COMPARISON: API_V2 + "/impact/community-comparison",
        IMPACT_JOURNY: API_V2 + "/impact/climate-journey",
        IMPACT_MILESTONES: API_V2 + "/impact/milestones",
        IMPACT_STATS: API_V2 + "/impact/metrics",
        IMPACT_CARDS: API_V2 + "/impact/eco-contribution",
    },
    ENERGY_REQUISITION: {
        ALL_REQUSITION_CARDS: API_V2 + "/users/energy-request/overview",
        ALL_PREV_CARDS: API_V2 + "/users/energy-request/history",
        ENERGY_REQUISITION_OVERVIEW: API_V2 + "/dashboard/consumer/energy-request/overview",
        OPT_IN_STATUS_UPDATE: (id: string) => API_V2 + `/users/energy-request/${id}/status`
    },

    OPT_ENERGY_FORM: {
        CONSUMER_DETAILS: API_V2 + "/users/consumer/details",
        SUBMIT_FORM: API_V2 + "/users/energy-request/submit"
    },

    BEE_REPORT: {
        RCO_SUBMIT: API_V2 + "/users/rco/subbmission",
        BEE_REPORT: API_V2 + "/dashboard/consumer/rco/report",
        TABLE_REPOERT: API_V2 + "/dashboard/consumer/rco/report-2",
    }

    // Add more endpoints as needed
} as const;

export {
    BASE_URL,
    API_ENDPOINTS,
    API_V1_BASE_URL,

}